import { Plugins } from '@leverege/plugin';
import ProcessorSetup from "./processors/PluginSetup.js";
import ActionsSetup from "./player/actions/PluginSetup.js";
export default {
  install(molten = Plugins) {
    ProcessorSetup.install(molten);
    ActionsSetup.install(molten);
  }
};